import React, { Suspense, useEffect } from "react";
import { useQueryLoader } from "react-relay";
import {
  AcquisitionPopupContainerDisplay,
  query,
} from "scmp-sdk/components/acquisition-popup-container/display";
import type { Props as DisplayProps } from "scmp-sdk/components/acquisition-popup-container/display";

import type { displayAcquisitionPopupContainerQuery } from "scmp-app/queries/__generated__/displayAcquisitionPopupContainerQuery.graphql";

export type Props = Omit<DisplayProps, "queryReference">;

export const AcquisitionPopupContainer: React.FunctionComponent<Props> = props => {
  const [queryReference, loadQuery, disposeQuery] =
    useQueryLoader<displayAcquisitionPopupContainerQuery>(query);

  useEffect(() => {
    loadQuery({});
    return disposeQuery;
  }, [loadQuery, disposeQuery]);

  return (
    <Suspense>
      {queryReference && (
        <AcquisitionPopupContainerDisplay {...props} queryReference={queryReference} />
      )}
    </Suspense>
  );
};

AcquisitionPopupContainer.displayName = "AcquisitionPopupContainer";
